import { Injectable } from '@angular/core';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor(){}

  formatDate(date: Date): string{
    return format(new Date(date), "dd/MM/yyyy", { locale: es });
  }

  formatDateToSpanish(date: Date){
    return format(new Date(date), "d 'de' MMMM 'de' yyyy", { locale: es });
  }

  formatDateTimeToSpanish(date: Date){
    return format(new Date(date), "d 'de' MMMM 'de' yyyy 'a las' HH:mm", { locale: es });
  }
}
